import axios from "axios";
import { API_BASE_URL } from "../../Services/api_url";

/**
 * Registers global axios interceptors (side-effect import).
 * The existing Services/*.ts call the default `axios` instance directly,
 * so attaching here covers every backend call app-wide.
 */
let installed = false;

export function installHttp(onUnauthorized?: () => void) {
  if (installed) return;
  installed = true;

  axios.defaults.baseURL = undefined; // services pass absolute URLs via API_BASE_URL

  axios.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers = config.headers ?? {};
      (config.headers as any).Authorization = `Bearer ${token}`;
    }
    return config;
  });

  axios.interceptors.response.use(
    (res) => res,
    (error) => {
      const status = error?.response?.status;
      // Only 401 (unauthenticated: missing/expired/invalid token) ends the
      // session. 403 (forbidden) is a permission result for the specific call
      // — e.g. a read-only tenant-inspection session, or a role probing an
      // endpoint it may not use — and must NOT log the user out.
      if (status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        if (onUnauthorized) onUnauthorized();
      }
      return Promise.reject(error);
    }
  );
}

export { API_BASE_URL };
